import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/nationalities',
    name: 'nationality',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/nationality')
  }
]
